import { render, staticRenderFns } from "./CompanySecuritySettings.vue?vue&type=template&id=7afb03d8&"
import script from "./CompanySecuritySettings.vue?vue&type=script&lang=js&"
export * from "./CompanySecuritySettings.vue?vue&type=script&lang=js&"
import style0 from "./CompanySecuritySettings.vue?vue&type=style&index=0&id=7afb03d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports